import React from 'react';
import styled from 'styled-components';

const Heading = styled.h2`
    margin-bottom: 30px;
    padding: 15px;
    font-size: 24px;
    font-size: 1.5rem;
    background-color:#009d80;
    color: #fff;
    border-radius: 7px;
`;

const Appeal = () => {
    return (
        <>
           <Heading>自分の『行きたい高校』を受験できるチャンスは1回のみ！</Heading>
           <p className='fw-bold border-bottom'>
            <span className='text-danger'>重要</span>&nbsp;&nbsp;高校の学科や定員変更が実施されます。受験校の決定に大きな影響がでますので、県教委からの情報に十分な注意を！
           </p>
           <p>「自分が興味のある進学したい高校」へは、まわりのみんなも行きたいんです！</p>
           <ul>
               <li>①A日程入試だけで定員が充足された学校・学科ではB日程での募集が全く行われない。</li>
               <li>②②	志願者が増えれば不合格者はもちろん増える。しかし、定員に満たない場合でも不合格者が出る。もちろん、入学試験に合格しないと入学させてくれない。</li>
               <li>受験生に人気のある学校は毎年高い倍率になっている。</li>
               <li>高校入試とは実際は恐ろしく厳しい！</li>
           </ul>
        </>
    );
}
export default Appeal;